<template>
  <div pagination>
    <a @click="prev" class="prev" :class="{disabled: pageNow < 2}"></a>
    <a v-for="page in pageList()" :key="page" :class="{on: page === pageNow }" @click="$emit('go', page)">{{ page }}</a>
    <a @click="next" class="next" :class="{disabled: totalPages === pageNow}"></a>
  </div>
</template>
<script>
export default {
  props: {
    result: { type: Object, default: null },
  },
  data() {
    return {
      totalPages: 0,
      pageNow: 0,
      pageStart: 0,
      pageEnd: 0,
    };
  },
  methods: {
    first() {
      if (this.pageNow === 1) return;
      this.$emit('go', 1);
    },
    prev() {
      if (this.pageNow === 1) return;
      this.$emit('go', this.pageNow - 1);
    },
    next() {
      if (this.pageNow === this.totalPages) return;
      this.$emit('go', this.pageNow + 1);
    },
    end() {
      if (this.pageNow === this.totalPages) return;
      this.$emit('go', this.totalPages);
    },
    pageList() {
      const result = [];
      if (!this.$props) {
        result.push(1);
        return result;
      }
      if (this.$props.result) {
        const data = this.$props.result;
        const len = 5;
        const c = data.pageNo;
        const t = data.pageCount;
        const s = (Math.floor(c / len) * len) + 1;
        const e = s + (t - s > len - 1 ? len - 1 : t - s);
        this.pageNow = c;
        this.totalPages = t;
        this.pageStart = s;
        this.pageEnd = e;
        for (let i = s; i <= e; i += 1) result.push(i);
      } else {
        this.pageNow = 0;
        this.totalPages = 0;
        this.pageStart = 0;
        this.pageEnd = 0;
        result.push(1);
      }
      return result;
    },
  },
};
</script>

<style lang="less" scoped>
  @import "../less/asset";
  @import "../less/gynpad";

  [pagination] { .tc; margin:18px 0;
    a { .ib; .vam; .wh(24px); line-height:24px;
      &.on { color: #f85c70; }
      &.prev, &.next { margin:0 10px; background:url("@{common}/paging-arr.png") no-repeat; background-size:contain; }
      &.next { transform:rotate(180deg); }
      &.disabled { opacity: 0.5; }
    }
  }

  @media (min-width: @screen-lg-min) {
    [pagination] { margin:40px 0;
      a { .wh(40px); line-height:40px; .fs(16px); }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue